import { inventoryValuationApi } from "../../../api/inventory/valuation";

export const MOVEMENT_PAGE_SIZE = 50;

export async function fetchMovementPage({ productId, storageId, from, to, mode, asOfAt, revision, costRevision, page }) {
  const response = await inventoryValuationApi.getMovements({
    product_id: productId,
    storage_id: storageId,
    from,
    to,
    mode,
    as_of_at: asOfAt,
    revision,
    cost_revision: costRevision,
    page,
    per_page: MOVEMENT_PAGE_SIZE,
  });
  const payload = response?.data;
  const rows = payload?.data?.movements || payload?.data?.rows;
  if (payload?.success !== true || !Array.isArray(rows)) throw new Error("Invalid movements response");
  return { rows, page, total: Number(payload.data.pagination?.total ?? rows.length) };
}
